module.exports = __webpack_public_path__ + "assets/img/newsBg.95553f62.png";